module.exports = __webpack_public_path__ + "c76cfa6dd84ea2ccfde27968775372b2.svg";